import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import '../../../Syntax.scss';

const SyntaxHighlighter = ({code, doc, scrollTop}) => { 
    let codes = [];
    let numberCode = code.replace(/[^0-9\n\s]/g, " ");
    let letterCode = code.replace(/[^a-zA-Z\n\s]/g, " ");
    let style = {top: -scrollTop};
    return [
        <pre style={style} className="syntax-highlighter number">
          {numberCode}
        </pre>,
        <pre style={style} className="syntax-highlighter letter">
          {letterCode}
        </pre>,
    ];
    let x = 5;
    for (let i=0; i < 5; i++) {
    }
} 

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SyntaxHighlighter);
